import React from "react";
import Header from "../components/Header";
import Footer from "../containers/Footer";


const About = () => {
  return (
    <>
      <Header />

      {/* Header */}
      <div className="bg-primary text-white text-center py-5 mt-5">
        <div className="container">
          <h1 className="display-4 fw-bold">About Us</h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
            Craft your resume with confidence
          </p>
        </div>
      </div>

      {/* About Content */}
      <section className="container py-5">
        <h2 className="fw-bold text-primary">About Us</h2>
        <p>
          Our Resume Builder is an online platform that simplifies the resume
          creation process for job seekers at all levels…
        </p>

        <p>
          With a guided step-by-step interface, pre-written content suggestions,
          and responsive templates…
        </p>

        <p>
          Our Resume Builder is an intuitive online platform designed to simplify
          the resume creation process…
        </p>

        <p>
          With pre-written content suggestions tailored to different industries,
          we eliminate stress…
        </p>

        <h3 className="mt-4 fw-semibold">Our Mission</h3>
        <p>
          Our mission is to empower job seekers by providing them with tools
          to create outstanding resumes…
        </p>

        <h3 className="mt-4 fw-semibold">What Sets Us Apart</h3>
        <ul>
          <li><strong>Continuous Updates:</strong> We update templates regularly.</li>
          <li><strong>Privacy & Security:</strong> Data protected with encryption.</li>
          <li><strong>Expert Guidance:</strong> Backed by HR professionals.</li>
          <li><strong>Community Support:</strong> Resume tips & support team.</li>
        </ul>

        <h3 className="mt-4 fw-semibold">Who Uses Resume Pilot?</h3>
        <p>
          Our platform is trusted by students, graduates, professionals…
        </p>

        <h3 className="mt-4 fw-semibold">Join Us</h3>
        <p>
          Join thousands who have landed interviews using our platform…
        </p>
      </section>

      {/* Images */}
      <section className="container mb-5">
        <h2 className="fw-bold text-primary">Screenshots</h2>
        <div className="row g-4 mt-2">
          <div className="col-md-4">
            <img src="/images/interface.png" className="img-fluid rounded shadow" alt="Interface" />
          </div>
          <div className="col-md-4">
            <img src="/images/templets.png" className="img-fluid rounded shadow" alt="Templates" />
          </div>
          <div className="col-md-4">
            <img src="/images/preview.png" className="img-fluid rounded shadow" alt="Preview" />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="bg-white py-5 border-top">
        <div className="container">
          <h2 className="fw-bold text-primary">Key Features</h2>

          <div className="row g-4 mt-4">
            {[
              { icon: "fa-suitcase", title: "Professional Templates" },
              { icon: "fa-brain", title: "Smart Assistance" },
              { icon: "fa-layer-group", title: "Section Flexibility" },
              { icon: "fa-file-pdf", title: "Multiple Export Options" },
              { icon: "fa-language", title: "Multilingual Support" },
              { icon: "fa-mobile", title: "Mobile Ready" },
            ].map((item, i) => (
              <div className="col-md-4" key={i}>
                <div className="card shadow-sm h-100">
                  <div className="card-body text-center">
                    <i className={`fa ${item.icon} fa-2x text-primary mb-3`}></i>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-5 bg-light">
        <div className="container text-center">
          <h2 className="fw-bold mb-3">Why Choose Us?</h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
            We provide expert-designed templates that help you stand out.
          </p>

          <div className="row g-4 mt-4 justify-content-center">
            <div className="col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h3 className="fw-bold">1</h3>
                  <h5>Easy to Use</h5>
                  <p>Simple UI. No design skills required.</p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h3 className="fw-bold">2</h3>
                  <h5>Professional Design</h5>
                  <p>Modern, elegant resume layouts.</p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h3 className="fw-bold">3</h3>
                  <h5>Affordable</h5>
                  <p>Premium quality at fair pricing.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="text-center py-5">
        <div className="container">
          <h3 className="fw-bold text-primary">Ready to Build Your Resume?</h3>
          <p className="text-muted">Start crafting your professional story today.</p>
          <button
            className="btn btn-primary px-4 py-2"
            onClick={() => (window.location.href = "/coming-soon")}
          >
            Start Building Now
          </button>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About;
